import React, { useEffect, useState } from "react";
import { Error, Success } from "../../../commons/Messages/Messages";
import { generalErrorAlert } from "../../GeneralErrorAlert";
import { isAuthenticated } from "../../Auth/auth";
import axios from "axios";
import AddLeaves from "./AddLeaves";
import { useContext } from "react";
import { SocketContext } from "../../../context/SocketContext";
import UpdateLeaveStatus from "./UpdateLeaveStatus";
import DeleteModal from "../../DeleteModal/DeleteModal";
import DropdownComp from "../../Dropdowns/DropdownComp";
import GeneralTable from "../../GeneralTable";
import { Tag } from "antd";
import dayjs from "dayjs";
import PageToolbar from "../../../design-system/PageToolbar";

import { useTranslation } from "react-i18next";
const EmployeLeaves = ({ employeeObject }) => {
  const { t } = useTranslation("dashboard");
  const socket = useContext(SocketContext);
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [pageSize] = useState(15);

  const getData = async () => {
    await axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/leaves/limited`,
        { employee: employeeObject?._id, pageSize, pageNo: pageNo - 1 },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      )
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          setData(res.data.data);
          setTotalCount(res.data.count);
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        Error(err.message);
      });
  };

  const refreshData = () => {
    getData();
  };

  // Same endpoint and flow as serviceProvider/components/leaves/Leaves.jsx. The Delete action
  // here used to call this handler without it being defined.
  const deleteHandler = async id => {
    await axios
      .delete(`${process.env.REACT_APP_BACKEND_URL}/leaves/delete/${id}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          Success(res.data.successMessage);
          getData();
          socket?.emit("refresh service provider data", {
            user: isAuthenticated()?.serviceProviderId
          });
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        generalErrorAlert(err);
      });
  };

  useEffect(() => {
    if (socket) {
      socket.on("refresh service provider data", msg => {
        if (msg) {
          refreshData();
        }
      });
    }
  }, [socket]);

  useEffect(() => {
    refreshData();

    return () => {};
  }, [pageNo]);

  const columns = [
    {
      title: "#",
      dataIndex: "_id",
      mobile: "hidden",
      render: (text, record, index) => index + 1
    },
    {
      title: t("Leave Type"),
      dataIndex: "leaveType",
      mobile: "title",
      sorter: (a, b) => a.leaveType.localeCompare(b.leaveType)
    },
    {
      title: t("Start Date"),
      dataIndex: "startDate",
      render: text => dayjs(text).format("DD/MMM/YYYY")
    },
    {
      title: t("End Date"),
      dataIndex: "endDate",
      render: text => dayjs(text).format("DD/MMM/YYYY")
    },
    {
      title: t("Reason"),
      dataIndex: "reason"
    },
    {
      title: t("Note"),
      dataIndex: "note"
    },
    {
      title: t("Status"),
      dataIndex: "status",
      sorter: (a, b) => a.status.localeCompare(b.status),
      mobile: "subtitle",
      render: status =>
        status ? (
          <Tag
            color={status === "Approved" ? "success" : status === "Rejected" ? "error" : "default"}
          >
            {t(status)}
          </Tag>
        ) : null
    },
    {
      title: t("Action"),
      key: "action",
      align: "right",
      render: (text, obj) => {
        const menuItems = [
          {
            key: "edit",
            component: () => <UpdateLeaveStatus data={obj} updateParent={getData} />
          },
          {
            key: "delete",
            component: () => <DeleteModal text="Leave" onClick={() => deleteHandler(obj?._id)} />
          }
        ];
        return (
          <div>
            <DropdownComp menuItems={menuItems} />
          </div>
        );
      }
    }
  ];

  return (
    <>
      <PageToolbar actions={<AddLeaves updateParent={getData} employeeObject={employeeObject} />} />
      <GeneralTable
        pageNo={pageNo}
        pageSize={pageSize}
        totalCount={totalCount}
        data={data}
        columns={columns}
        setPageNo={setPageNo}
      />
    </>
  );
};

export default EmployeLeaves;
